import React from "react";
import { menudb } from "./menudb.js";
import fondoMaderaGrande from "../../imagenes/fondoMaderaGrande.webp";
import fondoMaderaPequeno from "../../imagenes/fondoMaderaPequeno.webp";
const bdobentos = [...menudb[0].obentos];


function Obentos() {
  return (
    <div id="obentos">
      {/* CORN DOG 1 */}
      <div
        id="obento-1"
        className="relative bg-no-repeat bg-cover bg-center text-white min-h-screen flex flex-col items-center justify-center px-1 gap-5 py-4"
      >
        <p className="text-sm -tracking-tighter font-mono ">NUEVO PRODUCTO</p>
        <p className="text-3xl -tracking-tighter font-mono ">OBENTOS</p>
        <div className="grid grid-cols-2 max-md:grid-cols-1 gap-10">
          <div className=" flex w-[400px]">
            <img src={require(`../../imagenes/obentos/${bdobentos[0].image}-200-200.webp`)} className="bg-black/20 rounded-3xl" height={200} width={200} alt={bdobentos[0].name} loading="lazy" />
            <div >
              <div className="flex gap-4">
                <div className="text-3xl tracking-wide max-w-[80px] break-words">
                OBENTOS
                </div>
                
                <div className="w-[70px] py-2">
                  <hr className="w-[40px] border-2 border-white"></hr>
                  <p className="break-words">{bdobentos[0].name}</p>
                  <hr className="w-[40px] border-2 border-white"></hr>
                </div>
              </div>
              <p className="max-w-[180px] break-words text-sm">
                {bdobentos[0].description}
              </p>
              <p className="text-end text-2xl">s/. {bdobentos[0].price}</p>
              <hr className="w-[100px]"></hr>
            </div>
          </div>
           <div className=" flex w-[400px]">
            <img src={require(`../../imagenes/obentos/${bdobentos[1].image}-200-200.webp`)} className="bg-black/20 rounded-3xl" height={200} width={200} alt={bdobentos[1].name} loading="lazy" />
            <div >
              <div className="flex gap-4">
                <div className="text-3xl tracking-wide max-w-[80px] break-words">
                OBENTOS
                </div>
                
                <div className="w-[70px] py-2">
                  <hr className="w-[40px] border-2 border-white"></hr>
                  <p className="break-words">{bdobentos[1].name}</p>
                  <hr className="w-[40px] border-2 border-white"></hr>
                </div>
              </div>
              <p className="max-w-[180px] break-words text-sm">
                {bdobentos[1].description}
              </p>
              <p className="text-end text-2xl">s/. {bdobentos[1].price}</p>
              <hr className="w-[100px]"></hr>
            </div>
          </div>
        </div>
      </div>


    {/* Seccion 2 de obentos */}
      <div
        id="obento-2"
        className="relative bg-no-repeat bg-cover bg-center text-white min-h-screen flex flex-col items-center justify-center px-1 gap-5 py-4"
      >
        <div className="grid grid-cols-2 max-md:grid-cols-1 gap-10">
          <div className=" flex w-[400px]">
            <img src={require(`../../imagenes/obentos/${bdobentos[2].image}-200-200.webp`)} className="bg-black/20 rounded-3xl" height={200} width={200} alt={bdobentos[2].name} loading="lazy" />
            <div >
              <div className="flex gap-4">
                <div className="text-3xl tracking-wide max-w-[80px] break-words">
                OBENTOS
                </div>
                
                <div className="w-[70px] py-2">
                  <hr className="w-[40px] border-2 border-white"></hr>
                  <p className="break-words">{bdobentos[2].name}</p>
                  <hr className="w-[40px] border-2 border-white"></hr>
                </div>
              </div>
              <p className="max-w-[180px] break-words text-sm">
                {bdobentos[2].description}
              </p>
              <p className="text-end text-2xl">s/. {bdobentos[2].price}</p>
              <hr className="w-[100px]"></hr>
            </div>
          </div>
           <div className=" flex w-[400px]">
            <img src={require(`../../imagenes/obentos/${bdobentos[3].image}-200-200.webp`)} className="bg-black/20 rounded-3xl" height={200} width={200} alt={bdobentos[3].name} loading="lazy" />
            <div >
              <div className="flex gap-4">
                <div className="text-3xl tracking-wide max-w-[80px] break-words">
                OBENTOS
                </div>
                
                <div className="w-[70px] py-2">
                  <hr className="w-[40px] border-2 border-white"></hr>
                  <p className="break-words">{bdobentos[3].name}</p>
                  <hr className="w-[40px] border-2 border-white"></hr>
                </div>
              </div>
              <p className="max-w-[180px] break-words text-sm">
                {bdobentos[3].description}
              </p>
              <p className="text-end text-2xl">s/. {bdobentos[3].price}</p>
              <hr className="w-[100px]"></hr>
            </div>
          </div>
        </div>
       <div className="absolute top-0 right-0 w-full grid place-items-center h-[40px] bg-black/30 text-white">
          KoreanMania - Para ese antojiyo
        </div>
      </div>
      <style>
        {`
    @media (max-width: 768px){
      #obento-1, #obento-2{
        background-image: url(${fondoMaderaPequeno});
      }  
    }
    @media (min-width: 768px) {
      #obento-1, #obento-2 {
        background-image: url(${fondoMaderaGrande});
      }
    }
  `}
      </style>
    </div>
  );
}

export default Obentos;
